import { TransferCollegesWithCoursesQuery } from '../../queries/transfer_colleges_with_courses_query';
import { TransferConfiguration } from './../../config/transfer_configuration';
import { ICommand } from '../../../../vendor/core-ts-types/dist/main';

export class TransferCreditsRefineEstimateController {
  constructor(
    private ngTransferCollegesWithCoursesQuery: TransferCollegesWithCoursesQuery,
    private ngTransferConfiguration: TransferConfiguration,
    private deselectTransferCollegeCommand: ICommand
  ) {}
}
angular
  .module('capability-ng-transfer')
  .controller('ngTransferCreditsRefineEstimateController', TransferCreditsRefineEstimateController);



// WEBPACK FOOTER //
// ./app/lib/transfer/views/refine_estimate/refine_estimate.ts